/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/services/app.clock.service.ts.
 */
import {Injectable} from '@angular/core';
import {AppSettingsService} from './app.app_settings.service';
import {AppUserService} from './app.user.service';
import {BehaviorSubject} from 'rxjs';
import {AppEventService} from './app.event.service';

/**
 * Zweck: Beschreibt class AppClockService und ihren Daten- oder Funktionsvertrag.
 */
@Injectable({providedIn: 'root'})
export class AppClockService {
  position = new BehaviorSubject('none');
  style = new BehaviorSubject(null);

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private ssvc: AppSettingsService, private usvc: AppUserService, private esvc: AppEventService) {
    usvc.user$.subscribe(user => {
      if (usvc.isLoggedin) {
        this.load();
      } else {
        this.clear();
      }
    });
    this.esvc.getQueue().subscribe(ev => {
      if (ev.name == 'App\\Events\\SettingsEngine\\SettingsChangedEvent') {
        let load = false;
        if (ev.data.id.includes('ViewClockStyle') || ev.data.id.includes('ViewClockPosition')) {
          load = true;
        }
        if (load) {
          this.load();
        }
      }
    });
  }
/**
 * Beschreibt Methode clear und ihren Rückgabevertrag.
 */
  clear() {
    this.position.next('none');
    this.style.next(null);
  }

/**
 * Beschreibt Methode load und ihren Rückgabevertrag.
 */
  load() {
    this.ssvc.getUserSettingValue('ViewClockStyle').subscribe(style => {
      this.style.next(style);
    });

    this.ssvc.getUserSettingValue('ViewClockPosition').subscribe(pos => {
      this.position.next(pos);
    });
  }
}

